import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { ConcertAssignmentUserStatusDto } from "../dto/concert.dto"
import { concertService } from "../services/concert.service"

export const useGetConcertUserStatus = (
  proposalId: string,
  options?: { enabled?: boolean },
): UseQueryResult<ConcertAssignmentUserStatusDto> => {
  return useQuery({
    queryKey: queryKeys.concert.userStatus(proposalId),
    queryFn: () => concertService.getUserStatus(proposalId),
    enabled: options?.enabled ?? true,
  })
}
